import React, { Component } from 'react';
import './index.less';
import PropTypes from 'prop-types';
import { Layout, Modal, Spin } from 'antd';
import { FormattedMessage } from 'react-intl';
import MenuSider from './MenuSider';
import { Routes } from '../../util/router/routes';
import CompWrapper from './func';
import { msgCB } from '../../util/fetch/msgFetch';
import FormPassword from './formPassword';
import { sessionStore } from '../../util/storage';

const { Header, Content, Sider } = Layout;
const antIcon = require('../../static/image/loading.png');

let setIntervalID;
export class Page extends Component {
  componentDidMount() {
    const { auth, intl, getUser } = this.props;
    if (auth.status === 'LOGIN') {
      const { formatMessage } = intl;
      const cb = (res) => {
        msgCB(res.status, formatMessage, { all: false, UNAUTH: true });
      };
      setIntervalID = getUser(null, cb, setIntervalID);
    }
  }

  componentWillUnmount() {
    clearInterval(setIntervalID);
  }

  render() {
    const {
      className,
      filePath,
      user,
      intl,
      ui,
      routes,
      dispatch,
      onSubmit,
    } = this.props;
    let isCode = false;
    if (
      window.location.href.indexOf('code=') !== -1
      || sessionStore.get('ciamCode')
    ) {
      isCode = true;
    } else {
      isCode = false;
    }
    return (
      <div>
        {!isCode && <div className="spinCon" />}
        {!isCode && (
          <div className="spinContainer">
            <div className="spinBg">
              <div className="spinContent">
                <p className="imgCon">
                  <img className="loadingImg" src={antIcon} alt="" />
                </p>
                <p className="loadingText">
                  <span>Loading...</span>
                </p>
              </div>
            </div>
          </div>
        )}
        <Layout className={`${className} ${filePath}`}>
          <Header
            className="contentHeader"
            style={{ backgroundColor: isCode ? '#3DCD58' : '#ffffff' }}
          >
            {isCode && (
              <FormattedMessage
                id="Home.title"
                defaultMessage="hello {name} !"
                values={{
                  name: (
                    <Spin spinning={user.firstName === ''} className="spin">
                      {intl.locale === 'zh'
                        ? user.lastName + user.firstName
                        : `${user.firstName} ${user.lastName}`}
                    </Spin>
                  ),
                }}
              />
            )}
          </Header>
          <Layout className="subContent">
            <Sider className="contentSider" width="190">
              {isCode && <MenuSider ui={ui.uiMenuSider} />}
            </Sider>
            <Content className="formContent" style={{ backgroundColor: isCode ? '#F9F9F9' : '#ffffff' }}>
              <Routes routes={routes} />
            </Content>
          </Layout>
          <Modal
            title="Change Password"
            visible={user.forceChangePassword}
            maskClosable={false}
            footer={null}
            className="container_index_header_menu_MenuUser_Modal"
          >
            <FormPassword
              ui={ui.uiFormPassword}
              onSubmit={onSubmit}
              dispatch={dispatch}
            />
          </Modal>
        </Layout>
      </div>
    );
  }
}

Page.propTypes = {
  auth: PropTypes.shape({
    email: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['LOGGING', 'LOGIN', 'LOGOUT', null]),
  }).isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    forceChangePassword: PropTypes.bool.isRequired,
  }).isRequired,
  ui: PropTypes.shape({
    uiMenuSider: PropTypes.object.isRequired,
    uiFormPassword: PropTypes.object.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  routes: PropTypes.array.isRequired,
  getUser: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default CompWrapper(Page, 'container_Home');
